
import { Options, Vue } from 'vue-class-component'
import { mapState } from 'vuex'

@Options({
    data () {
        return {
            agree: false
        }
    },
    computed: {
        ...mapState(['userInfo', 'shareData', 'activityData'])
    },
    mounted () {
        this.$common.pageLoaded()
        let homeShareData = JSON.parse(JSON.stringify(this.shareData))
        homeShareData.link = window.location.href
        this.$common.onshare(homeShareData)
        this.$common.track('load', '进入首页')
    },
    methods: {
        handleAgree () {
            this.agree = !this.agree;
        },
        handleStart() {
            this.$router.push('/activity');
        }
    }
})
export default class Home extends Vue {}
